import { render, staticRenderFns } from "./FrameManual.vue?vue&type=template&id=1ed89472"
import script from "./FrameManual.vue?vue&type=script&lang=js"
export * from "./FrameManual.vue?vue&type=script&lang=js"
import style0 from "./FrameManual.vue?vue&type=style&index=0&id=1ed89472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports